<template>
  <div>
    <vue-toastr ref="filepondToast"></vue-toastr>
    <div v-if="!isMultiLang" class="form-group">
      <label>{{ label }}</label>
      <div v-if="!value" style="background:#eee;border-radius:15px;min-height:50px;">
        <file-pond
            ref="singlePond"
            name="image"
            label-idle="Hier klicken oder Bild reinziehen..."
            :allow-multiple="false"
            :accepted-file-types="acceptedFileTypes"
            maxFileSize="10MB"
            :server="pondServer(primaryIso)"
            @addfile="(e, f) => onAddFile(e, f, primaryIso)"
            @processfile="(e,f) => afterUpload(primaryIso, e, f)"
            :disabled="disabled"
        />
      </div>
      <div class="row" v-else>
        <div class="col-md-1" style="margin-top: 80px">
          <button class="btn btn-danger btn-sm" @click="$emit('input', null)" :disabled="disabled">
            <i class="fa fa-trash"></i>
          </button>
        </div>
        <div class="col-md-11"
             style="display:flex;align-items:center;background:#eee;border-radius:15px;padding:0 10px;">
          <div style="margin-left:10px;position:relative; text-align: center; width: 100%">
            <img :src="value" style="max-height:200px;"/>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="form-group">
      <label>{{ label }}</label>
      <ul class="nav nav-tabs">
        <li v-for="iso in isos" :key="iso" class="nav-item">
          <a class="nav-link" :class="{ active: activeIso === iso }"
              href="#"
              @click.prevent="activeIso = iso">
            <img :src="flagUrl(iso)" style="width:18px;border-radius:9px;margin-top:-4px;"/>
            {{ iso.toUpperCase() }}
          </a>
        </li>
        <li v-if="activeIso !== primaryIso && !isVideoActive"
            class="nav-item pull-right">
          <a class="nav-link" href="#"
              @click.prevent="aiTranslate"
              style="background-color:#1ab394;color:#fff;font-weight:400;border-bottom:none;cursor:pointer;">
            {{ translatingIso === activeIso ? 'Wird übersetzt ...' : '[Beta] Mit KI übersetzen' }}
          </a>
        </li>
        <li v-if="activeIso !== primaryIso && isVideoActive"
            class="nav-item pull-right">
          <a class="nav-link" href="#"
             style="background-color:#999;color:#fff;font-weight:400;border-bottom:none;cursor:not-allowed;"
             title="Videos können noch nicht automatisch übersetzt werden">
            KI nicht verfügbar
          </a>
        </li>
      </ul>
      <div class="tab-content" style="border:1px solid #ddd;border-top:none;padding:10px 20px;">
        <div v-for="iso in isos" :key="iso"
            v-show="activeIso === iso"
            style="position:relative;">
          <div v-if="!localImage(iso)" style="background:#eee;border-radius:15px;min-height:50px;">
            <file-pond
                :ref="'pond_' + iso"
                name="image"
                label-idle="Hier klicken oder Bild reinziehen..."
                :allow-multiple="false"
                :accepted-file-types="acceptedFileTypes"
                maxFileSize="10MB"
                :server="pondServer(iso)"
                @addfile="(e, f) => onAddFile(e, f, iso)"
                @processfile="(e,f) => afterUpload(iso, e, f)"
                :disabled="disabled"
            />
          </div>
          <div class="row" v-else>
            <div class="col-md-1"  style="margin-top: 80px">
              <button class="btn btn-danger btn-sm" @click="removeImage(iso)" :disabled="disabled">
                <i class="fa fa-trash"></i>
              </button>
            </div>
            <div class="col-md-11" style="display:flex;align-items:center;background:#eee;border-radius:15px;padding:0 10px;">
              <div style="margin-left:10px;position:relative; text-align: center; width: 100%">
                <img :src="localImage(iso)" style="max-width:100%; max-height:200px;"/>
              </div>
            </div>
          </div>
          <div v-show="translatingIso === iso"
              class="ai-overlay"
              style="position:absolute;inset:0;background:rgba(0,0,0,0.55);display:flex;align-items:center;justify-content:center;color:#fff;border-radius:4px;z-index:10;flex-direction:column;">
            <span class="ai-overlay-text">{{ overlayText }}</span>
          </div>
        </div>
      </div>

      <div v-if="showAiContext"
          class="ai-context-overlay"
          style="position:fixed;inset:0;z-index:1050;background:rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;"
          @click.self="showAiContext = false">
        <div
            style="background:#fff;border-radius:8px;box-shadow:0 4px 24px rgba(0,0,0,0.35);width:90%;max-width:480px;">
          <div style="padding:14px 20px;border-bottom:1px solid #e5e5e5;">
            <h4 style="margin:0;font-size:1.2rem;">KI-Übersetzung – Zusätzliche Informationen</h4>
          </div>
          <div style="padding:14px 20px;">
            <textarea
                v-model="aiContext"
                class="form-control"
                rows="4"
                placeholder="Hier können Sie der KI zusätzliche Informationen geben. Lassen Sie ansonsten dieses Feld bitte leer und klicken Sie auf 'Senden'."
            ></textarea>
          </div>
          <div style="padding:10px 20px;border-top:1px solid #e5e5e5;display:flex;gap:8px;justify-content:flex-end;">
            <button class="btn btn-secondary" @click="showAiContext = false">Abbrechen</button>
            <button class="btn btn-primary" @click="confirmAiTranslate">Senden</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import {aiTranslateImage} from './services/translationApi'

export default {
  name: 'FilepondTranslated',
  components: {VueToastr},
  props: {
    value: {type: String, default: ''},
    fieldPath: {type: String, required: true},
    label: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    isos: {type: Array, default: () => []},
    languages: {type: Object, default: () => ({})},
    flagCdnUrl: {type: String, default: '/images/flags/'},
    mediaFiles: {type: Object, default: () => ({})},
    acceptedFileTypes: {type: String, default: 'image/jpeg, image/png, image/webp'},
    uploadUrl: {type: String, default: '/api/content-hub/image/upload'},
    modelClass: {type: String, default: ''},
    modelId: {type: [Number, String], default: null},
    clientId: {type: Number, default: 0},
    scaleWidth: {type: Number, default: 0},
    scaleHeight: {type: Number, default: 0},
    minRatio: {type: Number, default: null},
    maxRatio: {type: Number, default: null},
    withoutConvert: {type: Boolean, default: false},
  },
  data() {
    return {
      activeIso: this.isos[0] || 'de',
      translatingIso: null,
      overlayText: 'Wird übersetzt...',
      showAiContext: false,
      aiContext: '',
      pendingAiIso: null,
      aiTimers: [],
    }
  },
  watch: {
    isos(val) {
      if (!val.includes(this.activeIso)) {
        this.activeIso = val[0] || 'de'
      }
    },
  },
  computed: {
    primaryIso() {
      return this.isos[0] || 'de'
    },
    isMultiLang() {
      return this.isos.length > 1
    },
    isVideoActive() {
      const url = this.localImage(this.activeIso)
      return url && (url.includes('.mov') || url.includes('.mp4') || url.includes('.webm'))
    },
  },
  methods: {
    localImage(iso) {
      if (iso === this.primaryIso) return this.value
      return this.mediaFiles[this.fieldPath]?.[iso] || null
    },
    pondRef(iso) {
      return iso === this.primaryIso && !this.isMultiLang ? 'singlePond' : 'pond_' + iso
    },
    pondServer(iso) {
      return {
        url: this.uploadUrl,
        process: {
          url: '',
          method: 'POST',
          withCredentials: true,
          headers: {},
          timeout: 60000,
          ondata: (formData) => {
            formData.append('iso', iso)
            formData.append('field_name', this.fieldPath)
            formData.append('model_class', this.modelClass)
            if (this.modelId) formData.append('model_id', this.modelId)
            formData.append('client_id', this.clientId)
            if (this.scaleWidth && this.scaleHeight) {
              formData.append('scale_width', this.scaleWidth)
              formData.append('scale_height', this.scaleHeight)
            }
            if (this.withoutConvert) {
              formData.append('without_convert', '1')
            }
            return formData
          },
        },
      }
    },
    onAddFile(error, fileItem, iso) {
      if (error || !fileItem?.file || !this.minRatio || !this.maxRatio) return

      const file = fileItem.file
      if (!file.type.startsWith('image/')) return

      const img = new Image()
      img.onload = () => {
        const actualRatio = img.width / img.height
        const min = parseFloat(this.minRatio)
        const max = parseFloat(this.maxRatio)
        const isValid = actualRatio >= min && actualRatio <= max

        if (!isValid) {
          const pond = this.$refs[this.pondRef(iso)]
          if (pond) pond.removeFile(fileItem.id)
          this.$refs.filepondToast.e(
              `Erlaubt sind Seitenverhältnisse zwischen ${min} und ${max}.`,
              'Fehler'
          )
        }
      }
      img.onerror = () => {
        this.$refs.filepondToast.e('Bild konnte nicht geladen werden', 'Fehler')
      }
      img.src = URL.createObjectURL(file)
    },
    afterUpload(iso, error, file) {
      let response
      try {
        response = JSON.parse(file.serverId)
      } catch {
        response = null
      }

      if (Array.isArray(response) && response.length > 0) {
        this.$emit('multi-upload', { fieldPath: this.fieldPath, iso, urls: response })
        return
      }

      const url = response?.content_url || response?.url || file.serverId || null
      if (!url) return
      const cleanUrl = url.replace(/\/\/+/g, '/').replace(/https?:\//, (m) => m.replace('/', '//'))
      if (iso === this.primaryIso) {
        this.$emit('input', cleanUrl)
      }
      this.$emit('media-updated', { fieldPath: this.fieldPath, iso, url: cleanUrl })
    },
    removeImage(iso) {
      if (iso === this.primaryIso) {
        this.$emit('input', null)
      }
      this.$emit('media-updated', {fieldPath: this.fieldPath, iso, url: null})
    },
    flagUrl(iso) {
      const code = iso === 'en' ? 'gb' : iso
      return this.flagCdnUrl + code + '.svg'
    },
    aiTranslate() {
      const targetIso = this.activeIso
      if (targetIso === this.primaryIso || this.translatingIso) return
      const sourceUrl = this.localImage(this.primaryIso)
      if (!sourceUrl) {
        alert('Bitte zuerst ein Bild für die Ausgangssprache (' + this.primaryIso.toUpperCase() + ') hochladen.')
        return
      }
      this.pendingAiIso = targetIso
      this.aiContext = ''
      this.showAiContext = true
    },
    async confirmAiTranslate() {
      const targetIso = this.pendingAiIso
      if (!targetIso) return
      this.showAiContext = false
      this.translatingIso = targetIso

      this.overlayText = 'Bild wird hochgeladen'
      const timerTexts = [
        {ms: 1500, text: 'Bildgenerator wird gestartet'},
        {ms: 3000, text: 'Verarbeitung beginnt'},
        {ms: 5500, text: 'Änderungen werden skizziert'},
        {ms: 10000, text: 'Bild wird erstellt'},
        {ms: 16500, text: 'Ergebnis wird geprüft'},
        {ms: 19000, text: 'Letzter Feinschliff'},
      ]
      this.aiTimers = timerTexts.map(({ms, text}) =>
          setTimeout(() => {
            this.overlayText = text
          }, ms)
      )

      try {
        const formData = new FormData()
        formData.append('modelClass', this.modelClass)
        formData.append('modelId', this.modelId || '__NEW__')
        formData.append('fieldName', this.fieldPath)
        formData.append('sourceIso', this.primaryIso)
        formData.append('targetIso', targetIso)
        formData.append('clientId', this.clientId || 0)
        formData.append('additionalContext', this.aiContext || '')

        const sourceUrl = this.localImage(this.primaryIso)
        const blob = await fetch(sourceUrl).then(r => r.blob())
        formData.append('source_file', blob, 'source_' + this.primaryIso + '.png')

        const data = await aiTranslateImage(formData)
        const resultUrl = data.image || 'data:image/png;base64,' + (data.image_base64 || '')

        this.$emit('media-updated', {fieldPath: this.fieldPath, iso: targetIso, url: resultUrl})
      } catch {
        alert('Fehler bei der KI-Bildübersetzung')
      } finally {
        this.aiTimers.forEach(t => clearTimeout(t))
        this.aiTimers = []
        this.translatingIso = null
        this.pendingAiIso = null
      }
    },
  },
}
</script>

<style scoped>
.nav-tabs .nav-link {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ddd;
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.nav-tabs .nav-link.active {
  font-weight: 600;
  background: #ddd;
  color: #6a6a6a;
}
</style>